export type ApplicationImportance =
  | 'UNIMPORTANT'
  | 'LOW'
  | 'MEDIUM'
  | 'HIGH'
  | 'CRITICAL'

export const allImportances: ApplicationImportance[] = [
  'UNIMPORTANT',
  'LOW',
  'MEDIUM',
  'HIGH',
  'CRITICAL'
]

export const appImportanceI18n: Record<ApplicationImportance, string> = {
  UNIMPORTANT: 'title_appImportanceLevelUnimportant',
  LOW: 'title_appImportanceLevelLow',
  MEDIUM: 'title_appImportanceLevelMedium',
  HIGH: 'title_appImportanceLevelHigh',
  CRITICAL: 'title_appImportanceLevelCritical'
}
